import { Component, OnInit,Input,ViewChild } from '@angular/core';
import { ChartOptions, ChartType, ChartDataSets} from 'chart.js';
import { MultiDataSet, Label,PluginServiceGlobalRegistrationAndOptions } from 'ng2-charts';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import { SurveyStatusV2Service } from "../../survey-status-v2.service";
import {MatTableDataSource} from '@angular/material/table';
import { ModalComponent } from "app/main/pagina/tools/survey-status-v2/contenido/acciones/modal/modal.component";
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import * as backInter from 'app/auth/auth-data.model';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import {MatPaginator} from '@angular/material/paginator';
@Component({
  selector: 'auditoria',
  templateUrl: './auditoria.component.html',
  styleUrls: ['./auditoria.component.scss']
})
export class AuditoriaComponent implements OnInit {
@Input() infoEmpresaProducto: Observable<any>;
 @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
datosEmpresaProducto: any = {};
OverallStatus:number;
OverallStatus_color:any;
ControlStatementDeviation_color:any;
RandomStatementFail_color:any;
TimeToAnswerDeviation_color:any;
datosMasterTable: any = [];
infoAudManual: any;
mostrarTabla:boolean=false;

  categorias = [
    {
      nombre: 'Correos',
      id: 'correos',
      acciones: [
        { id: 'enviaCorreos', nombre: 'Ver primeros 1000', icono: 'send', bloqueado: true, funcion: 'enviaCorreos',class:'class1' },
        { id: 'getEnviados', nombre: 'Buscar colaborador', icono: 'cached', bloqueado: true, funcion: 'getEnviados',class:'class2' },
        { id: 'otra cosa', nombre: 'Buscar colaborador', icono: 'cached', bloqueado: true, funcion: 'noce',class:'class3' },
      ]
    },
  ];

  displayedColumns: string[] = ['HierarchicalPath', 'RespondentCount', 'Time_DeviationCount', 'Time_DeviationPercentage','ControlStatement_DeviationCount','ControlStatement_DeviationPercentage','RandomStatement_DeviationPercentage','RandomStatement_DeviationCount'];
  doughnutChartPluginsTiempoRespuesta: PluginServiceGlobalRegistrationAndOptions[];
  donutColorsTiempoRespuesta: any[];
  doughnutChartLabelsTiempoRespuesta: Label[] = [];
  doughnutChartDataTiempoRespuesta: MultiDataSet = [];
  doughnutChartOptionsTiempoRespuesta:any={};
  doughnutChartType: ChartType = 'doughnut';

  doughnutChartPluginsPreguntaControl: PluginServiceGlobalRegistrationAndOptions[];
  donutColorsPreguntaControl: any[];
  doughnutChartLabelsPreguntaControl: Label[] = [];
  doughnutChartDataPreguntaControl: MultiDataSet = [];
  doughnutChartOptionsPreguntaControl:any= {};

  doughnutChartPluginsPreguntaAleatoria: PluginServiceGlobalRegistrationAndOptions[];
  donutColorsPreguntaAleatoria: any[];
  doughnutChartLabelsPreguntaAleatoria: Label[] = [];
  doughnutChartDataPreguntaAleatoria: MultiDataSet = [];
  doughnutChartOptionsPreguntaAleatoria:any= {};
  result:any;
  records:any;
  tablaAuditoriaAutomatizada: any;
  getLogPrimVez: boolean;
  constructor(
    private translateSrv: TranslateService,
    private surveyServ: SurveyStatusV2Service,
    private dialog: MatDialog,

  ) {
    this.translateSrv.onLangChange.subscribe(() => {
      console.log('La mando a llamar otra vez y  otra vez');
          this.cambioNamePaginator();
    });


   }

  ngOnInit(): void {
    this.infoEmpresaProducto.subscribe((datos:any) => {
      for(let prop in datos){
        this.datosEmpresaProducto[prop] = datos[prop];
      }
      // console.log("datosEmpresaLogMails:",this.datosEmpresaProducto);
      if(this.datosEmpresaProducto.datosProducto && !this.getLogPrimVez){
        this.getLogPrimVez = true;
        if(this.datosEmpresaProducto.tipoProducto != 3 ){
          // console.log("El producto No es norma 35");
          switch (this.datosEmpresaProducto.tipoProducto) {
            case 63:

              break;

            default:
            this.getAutomatedAuditInfos(this.datosEmpresaProducto.idProducto);
            this.getInfoAudManual();
              break;
          }

      }else{
        // console.log("El producto es norma 35");
      }
      }
    });


  }

  getAutomatedAuditInfos(idProdcto){
    // console.log('idProdcto',idProdcto);
      this.surveyServ.getAutomatedAuditInfo(idProdcto).subscribe((respuesta:any) => {
        // console.log("getAutomatedAuditInfo:",respuesta);
        if (respuesta.success) {
          this.mostrarTabla=true;
          this.result=respuesta.result;
          this.records=respuesta.records;
          this.OverallStatus=this.result.OverallStatus;
          this.OverallStatus_color=this.result.OverallStatus_color;
          this.ControlStatementDeviation_color=this.result.ControlStatementDeviation_color;
          this.RandomStatementFail_color=this.result.RandomStatementFail_color;
          this.TimeToAnswerDeviation_color=this.result.TimeToAnswerDeviation_color;
          if (this.result.TimeToAnswerDeviationPercent!=null) {
            this.GraficaDonaTiempoRespuesta(this.result.TimeToAnswerDeviationPercent);

          }
          if (this.result.ControlStatementDeviationPercent!=null) {
            this.GraficaDonaPreguntaControl(this.result.ControlStatementDeviationPercent);

          }
          if (this.result.RandomStatementFailPercent!=null) {

            this.GraficaDonaPreguntaAleatoria(this.result.RandomStatementFailPercent);
          }
          this.tablaAuditoriaAutomatizada = new MatTableDataSource<any>(this.records);
          setTimeout(() => {
            this.tablaAuditoriaAutomatizada.paginator = this.paginator;
            this.paginator._intl.itemsPerPageLabel=this.translateSrv.instant('AUDITORIA.TIT_PAGI_TABL');

          }, 1000);
        }else{
          this.mostrarTabla=false;
        }
      });

  }

  GraficaDonaTiempoRespuesta(porcentaje:number){
    let tiempoRespuesta: number = porcentaje;

    let porcentajeFaltante=0;


    this.doughnutChartLabelsTiempoRespuesta= [];
    this.doughnutChartOptionsTiempoRespuesta= {}
    this.doughnutChartDataTiempoRespuesta= [
      [tiempoRespuesta]
    ];

    this.doughnutChartOptionsTiempoRespuesta = {
     responsive: true,
      tooltips:{
       enabled: false,
      }
    }

    this.donutColorsTiempoRespuesta = [
        {
          backgroundColor: [
            this.TimeToAnswerDeviation_color,
            this.TimeToAnswerDeviation_color,

          ],
          hoverBackgroundColor: [

            this.TimeToAnswerDeviation_color,
            this.TimeToAnswerDeviation_color,

            ]
        }
      ];

  this.doughnutChartPluginsTiempoRespuesta= [{

         beforeDraw(chart) {
           let ctx = chart.ctx;
           let txt = 'Center Text';

           //Get options from the center object in options
           const sidePadding = 60;


           ctx.textAlign = 'center';
           ctx.textBaseline = 'middle';
           const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
           const centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);

           //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
           const stringWidth = ctx.measureText(txt).width;


           // Find out how much the font can grow in width.



           ctx.font ='25px Arial';
           ctx.fillStyle = '#087272';

           // Draw text in center
           ctx.fillText(tiempoRespuesta+'%', centerX, centerY);
         }
       }];







  }
  GraficaDonaPreguntaControl(porcentaje:number){
    let prguntaControl: number = porcentaje

    let porcentajeFaltante=0;


    this.doughnutChartLabelsPreguntaControl= [];
    this.doughnutChartOptionsPreguntaControl= {}
    this.doughnutChartDataPreguntaControl= [
      [prguntaControl]
    ];

    this.doughnutChartOptionsPreguntaControl = {

     responsive: true,
      tooltips:{
       enabled: false,
      }
    }

    this.donutColorsPreguntaControl = [
        {
          backgroundColor: [
            this.ControlStatementDeviation_color,
            this.ControlStatementDeviation_color,

          ],
          hoverBackgroundColor: [

            this.ControlStatementDeviation_color,
            this.ControlStatementDeviation_color,

            ]
        }
      ];

  this.doughnutChartPluginsPreguntaControl= [{

         beforeDraw(chart) {
           let ctx = chart.ctx;
           let txt = 'Center Text';

           //Get options from the center object in options
           const sidePadding = 60;


           ctx.textAlign = 'center';
           ctx.textBaseline = 'middle';
           const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
           const centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);

           //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
           const stringWidth = ctx.measureText(txt).width;


           // Find out how much the font can grow in width.



           ctx.font ='25px Arial';
           ctx.fillStyle = '#087272';

           // Draw text in center
           ctx.fillText(prguntaControl+'%', centerX, centerY);
         }
       }];

  }

  GraficaDonaPreguntaAleatoria(porcentaje:number){
    let preguntaAleatoria: number = porcentaje

    let porcentajeFaltante=0;


    this.doughnutChartLabelsPreguntaAleatoria= [];
    this.doughnutChartOptionsPreguntaAleatoria= {}
    this.doughnutChartDataPreguntaAleatoria= [
      [preguntaAleatoria]
    ];

    this.doughnutChartOptionsPreguntaAleatoria = {
     responsive: true,
      tooltips:{
       enabled: false,
      }
    }

    this.donutColorsPreguntaAleatoria = [
        {
          backgroundColor: [
            this.RandomStatementFail_color,
            this.RandomStatementFail_color,

          ],
          hoverBackgroundColor: [

            this.RandomStatementFail_color,
            this.RandomStatementFail_color,

            ]
        }
      ];

  this.doughnutChartPluginsPreguntaAleatoria= [{

         beforeDraw(chart) {
           let ctx = chart.ctx;
           let txt = 'Center Text';

           //Get options from the center object in options
           const sidePadding = 60;


           ctx.textAlign = 'center';
           ctx.textBaseline = 'middle';
           const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
           const centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);

           //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
           const stringWidth = ctx.measureText(txt).width;


           // Find out how much the font can grow in width.



           ctx.font ='25px Arial';
           ctx.fillStyle = '#087272';

           // Draw text in center
           ctx.fillText(preguntaAleatoria+'%', centerX, centerY);
         }
       }];

  }

  exportTable(){
    // Swal.showLoading()
    var wb = XLSX.utils.book_new();
    wb.Props = {
      // Title: this.translateSrv.instant("COLABORADORES.EXCEL.TITUARCHIVO"),
      Title: 'sdcmask',
      Subject: 'CULTURAL GO',
      Author: 'ITBM',
      CreatedDate: new Date()
    };
    wb.SheetNames.push('hoja');
    var ws_data = [];
    let nombresColumnas:string[] = [];
    backInter.CLAVES_COLUMNASAUDITORIA.forEach( (nombre) => {
      switch(nombre){

        case 'HierarchicalPath': nombresColumnas.push(this.translateSrv.instant('AUDITORIA.COLUMNAS.HierarchicalPath')); break;
        case 'RespondentCount': nombresColumnas.push(this.translateSrv.instant('AUDITORIA.COLUMNAS.RespondentCount')); break;
        case 'Time_DeviationCount': nombresColumnas.push(this.translateSrv.instant('AUDITORIA.COLUMNAS.Time_DeviationCount')); break;
        case 'Time_DeviationPercentage': nombresColumnas.push(this.translateSrv.instant('AUDITORIA.COLUMNAS.Time_DeviationPercentage')); break;
        case 'ControlStatement_DeviationCount': nombresColumnas.push(this.translateSrv.instant('AUDITORIA.COLUMNAS.ControlStatement_DeviationCount')); break;
        case 'ControlStatement_DeviationPercentage': nombresColumnas.push(this.translateSrv.instant('AUDITORIA.COLUMNAS.ControlStatement_DeviationPercentage')); break;
        case 'RandomStatement_DeviationPercentage': nombresColumnas.push(this.translateSrv.instant('AUDITORIA.COLUMNAS.RandomStatement_DeviationPercentage')); break;
        case 'RandomStatement_DeviationCount': nombresColumnas.push(this.translateSrv.instant('AUDITORIA.COLUMNAS.RandomStatement_DeviationCount')); break;

      }
    });
    console.log("Colaboradores")
    ws_data.push(nombresColumnas);
    this.records.forEach( (infoColab) => {
      let datosColaboradores:any[] = [];
      backInter.CLAVES_COLUMNASAUDITORIA.forEach( (nombre) => {
        switch(nombre){
          case 'HierarchicalPath': datosColaboradores.push(infoColab.HierarchicalPath); break;
          case 'RespondentCount': datosColaboradores.push(infoColab.RespondentCount); break;
          case 'Time_DeviationCount': datosColaboradores.push(infoColab.Time_DeviationCount); break;
          case 'Time_DeviationPercentage': datosColaboradores.push(infoColab.Time_DeviationPercentage); break;
          case 'ControlStatement_DeviationCount': datosColaboradores.push(infoColab.ControlStatement_DeviationCount); break;
          case 'ControlStatement_DeviationPercentage': datosColaboradores.push(infoColab.ControlStatement_DeviationPercentage); break;
          case 'RandomStatement_DeviationPercentage': datosColaboradores.push(infoColab.RandomStatement_DeviationPercentage); break;
          case 'RandomStatement_DeviationCount': datosColaboradores.push(infoColab.RandomStatement_DeviationCount); break;
        }
      });
      ws_data.push(datosColaboradores);
      // console.log(ws_data);
    });
    var ws = XLSX.utils.aoa_to_sheet(ws_data);
    wb.Sheets['hoja'] = ws;
    var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
    var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
    var view = new Uint8Array(buf);  //create uint8array as viewer
    for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet
    // saveAs(new Blob([buf],{type:"application/octet-stream"}), `${this.translateSrv.instant("COLABORADORES.EXCEL.TITUARCHIVO")}.xlsx`);
    saveAs(new Blob([buf],{type:"application/octet-stream"}), `${'Auditoria'}.xlsx`);
    Swal.close();
  }

  getInfoAudManual(){
    this.surveyServ.getInfoAudManual().subscribe((respuesta:any) => {
      // console.log("getInfoAudManual:",respuesta);
      if(respuesta.success){
        this.infoAudManual = respuesta.result;
      }
    });
  }

  auditoriaManual(){
    this.surveyServ.getInfoAudManual().subscribe((respuesta:any) => {
      console.log("getInfoAudManual:",respuesta);
      if(respuesta.success){
        this.infoAudManual = respuesta.result;
      }
    });
    setTimeout(() => {
      const dialogRef = this.dialog.open(ModalComponent, {
        width: '50%',
        disableClose: true,
        data: {
          tipo: 'auditoriaManual',
          info: JSON.parse(JSON.stringify(this.infoAudManual))
        }
      });
      console.log("infoAudManual:",this.infoAudManual);
      dialogRef.afterClosed().subscribe(result => {
        console.log("resultado:",result);
        if(result != undefined){
          if(!_.isEqual(this.infoAudManual, result)){
            console.log("es diferente");
            this.infoAudManual = result;
            let datosInfoManual = {
              productoId: this.datosEmpresaProducto.idProducto,
              manualAudit_status : result.ManualAudit_Status,
              manualAudit_result : result.ManualAudit_Result,
              manualAudit_text : result.ManualAudit_Text,
              manualAudit_auditorName : result.ManualAudit_AuditorName
            };
            this.surveyServ.setInfoAudManual(datosInfoManual).subscribe((respuesta:any) => {
              console.log("setInfoAudManual:",respuesta);
              this.getAutomatedAuditInfos(this.datosEmpresaProducto.idProducto);
            });
            //reinicia la master table
            this.datosMasterTable = [];
          } else{
            console.log("es igual, no hay cambios");

          }
        }
      });

    }, 3000);


  }

  cambioNamePaginator(){
    console.log("es igual, no hay cambios");
    this.paginator._intl.itemsPerPageLabel=this.translateSrv.instant('AUDITORIA.TIT_PAGI_TABL');
  }
}
